import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon, CheckCircle2Icon } from 'lucide-react';
import { getText, isRtl, type Lang } from './translations';
export function LocationRewardSlide({
  onNext,
  onBack,
  lang = 'en' as Lang
}: {
  onNext: () => void;
  onBack: () => void;
  lang?: Lang;
}) {
  const rtl = isRtl(lang);
  return <div className="flex flex-col h-full relative z-10 bg-white" dir={rtl ? 'rtl' : 'ltr'} data-id="element-466">
      {/* Back button overlaying the image */}
      <div className={`absolute top-8 ${rtl ? 'right-6' : 'left-6'} z-20`} data-id="element-467">
        <button onClick={onBack} className="p-2 text-slate-400 hover:text-stone-600 transition-colors bg-white/80 backdrop-blur-sm rounded-full shadow-sm border border-stone-100" aria-label="Go back" data-id="element-468">
          <ArrowLeftIcon className={`w-5 h-5 ${rtl ? 'rotate-180' : ''}`} data-id="element-469" />
        </button>
      </div>

      {/* Large examination room image */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.6
    }} className="w-full h-56 relative overflow-hidden rounded-b-3xl shadow-sm flex-shrink-0" data-id="element-470">
        <img src="https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?q=80&w=1000&auto=format&fit=crop" alt="Modern examination room" className="w-full h-full object-cover" data-id="element-471" />
        <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent opacity-70" data-id="element-472" />
      </motion.div>

      {/* Content */}
      <div className="flex-1 flex flex-col px-6 max-w-sm mx-auto w-full pt-6 pb-8" data-id="element-473">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="text-center flex flex-col items-center" data-id="element-474">
          <div className="inline-flex items-center space-x-2 rtl:space-x-reverse bg-nhs-blue/10 text-nhs-blue px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide mb-4 border border-nhs-blue/20" data-id="element-475">
            <CheckCircle2Icon className="w-3.5 h-3.5" data-id="element-476" />
            <span data-id="element-477">{getText('insight', lang)}</span>
          </div>

          <h2 className="text-2xl font-semibold text-slate-900 leading-tight mb-6" data-id="element-478">
            {getText('locationInsightTitle', lang)}
          </h2>

          <div className="bg-white p-6 rounded-2xl border border-stone-200 shadow-sm text-left" dir={rtl ? 'rtl' : 'ltr'} data-id="element-479">
            <p className="text-stone-600 leading-relaxed font-medium" data-id="element-480">
              {getText('locationInsightBody', lang)}
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="mt-auto pt-6" data-id="element-481">
          <button onClick={onNext} className="w-full py-4 bg-nhs-blue text-white rounded-xl font-semibold text-lg flex items-center justify-center hover:bg-nhs-darkblue transition-colors shadow-md shadow-nhs-blue/20 active:scale-[0.98]" data-id="element-482">
            {getText('continue', lang)}
          </button>
        </motion.div>
      </div>
    </div>;
}